import * as React from 'react'
import { type FieldError } from 'react-hook-form'

import { cn } from 'utils/classMerge'

import Label from '../label'

import { Error } from './error'

type FieldWrapperProps = {
  /** Label text displayed above the input */
  label?: string
  /** Class name for the field wrapper div */
  className?: string
  /** Class name for the input wrapper div, used when input needs specific container styling */
  inputWrapperClassName?: string
  /** Children elements to be rendered inside the field wrapper */
  children: React.ReactNode
  /** Error object from react-hook-form */
  error?: FieldError | undefined
}

export type FieldWrapperPassThroughProps = Omit<
  FieldWrapperProps,
  'className' | 'children'
>

export const FieldWrapper = React.forwardRef(
  (
    {
      label,
      error,
      children,
      className,
      inputWrapperClassName,
    }: FieldWrapperProps,
    forwardRef: React.ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <div
        className={cn('tw-flex tw-flex-col tw-gap-1', className)}
        data-testid="field-wrapper"
      >
        {label && (
          <Label className="tw-text-left tw-text-sm tw-font-medium tw-capitalize tw-text-zinc-950">
            {label}
          </Label>
        )}
        {inputWrapperClassName ? (
          <div className={cn(inputWrapperClassName)} ref={forwardRef}>
            {children}
          </div>
        ) : (
          children
        )}
        <Error errorMessage={error?.message} />
      </div>
    )
  },
)
